/**
 * Firebase initialization — Landlord
 * Guard against double-initialization during HMR.
 * getMessaging is wrapped in try/catch because it throws
 * if the environment does not support service workers
 * (e.g. during SSR, testing, or when service workers are disabled).
 */

import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, type Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Guard against double-initialization in HMR
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

let messaging: Messaging | null = null;
try {
  messaging = getMessaging(app);
} catch {
  // getMessaging throws if the environment doesn't support it
  // (e.g., during testing or if service workers are unavailable)
  console.warn('Firebase Messaging is not supported in this environment');
}

export { messaging };
